<template>
    <div class="grid grid-cols-12 base-responsive-gap">
        <div class="col-span-12 lg:col-span-10 lg:col-start-2">
            <div
                class="rounded-3xl sm:rounded-full px-8 py-6 flex flex-col sm:flex-row justify-between items-center"
                :class="type === 'event' ? 'bg-blue-500 dark bg-theme-dark' : 'bg-yellow-400'"
            >
                <span
                    class="uppercase font-Poppins font-semibold mb-4 sm:mb-0 sm:w-1/2 sm:pr-4 text-center sm:text-left dark:text-white"
                >
                    <T :t="labelTextKey" />
                </span>
                <Button
                    :label="buttonText"
                    :to="buttonUrl"
                    class="p-button-secondary p-button-text"
                    icon="pi pi-arrow-right"
                    icon-pos="right"
                />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TopLocationProjectPageBanner',
    props: {
        labelTextKey: {
            type: String,
            required: true,
        },
        buttonText: {
            type: String,
            required: true,
        },
        buttonUrl: {
            type: String,
            required: true,
        },
        type: {
            type: String,
            required: false,
            default: null,
        },
    },
};
</script>

<style scoped></style>
